import React, { useState } from "react";

const JsonNode = ({ data, name }: { data: any; name?: string }) => {
    const [expanded, setExpanded] = useState(true);

    const toggleExpand = () => setExpanded(!expanded);
    const isArray = Array.isArray(data);
    const isObject = typeof data === "object" && data !== null;

    if (isArray || isObject) {
        const itemCount = isArray ? data.length : Object.keys(data).length;
        const openSymbol = isArray ? "[" : "{";
        const closeSymbol = isArray ? "]" : "}";

        return (
            <div className={`ml-${name ? "3" : "0"}`}>
                <span
                    onClick={toggleExpand}
                    className="font-weight-bold text-secondary"
                    style={{ cursor: "pointer" }}
                >
                    {expanded ? "▼" : "▶"} {name && <span className="text-success">{name}: </span>}
                    {!expanded && `${openSymbol}${itemCount} item${itemCount > 1 ? "s" : ""}${closeSymbol}`}
                </span>
                {expanded && (
                    <div className="ml-3 pl-2 border-left">
                        <span className="text-muted">{openSymbol}</span>
                        {(isArray ? data : Object.entries(data)).map((item: any[] | string, index: number) => (
                            <JsonNode
                                key={isArray ? index : item[0]}
                                data={isArray ? item : item[1]}
                                name={isArray ? undefined : item[0]}
                            />
                        ))}
                        <span className="text-muted">{closeSymbol}</span>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="ml-3">
            {name && <strong className="text-success">{name}: </strong>}
            <span className="text-primary font-weight-bold">{JSON.stringify(data)}</span>
        </div>
    );
};

const JSONFormatter = ({ jsonData }: { jsonData: any }) => (
    <div className="mt-4">
        <div className="bg-light p-3 rounded border">
            <JsonNode data={jsonData} />
        </div>
    </div>
);

export default JSONFormatter;
